import { getMetricsApi, getMetricNameApi, linkMetricApi, unlinkMetricApi, getQueryStringApi } from 'api/goalTracking';
import PluginMetric from 'models/pluginMetric';

export const getMetrics = ({ taskId, pluginType }) =>
  getMetricsApi({ taskId, pluginType }).then((res) => {
    const metric = new PluginMetric();
    metric.fromJSON(res.entity);
    return metric;
  });

export const getMetricName = ({ taskId }) => getMetricNameApi({ taskId }).then((res) => res.entity);

export const linkMetric = ({
  taskId,
  metricId,
  pluginType,
  filters,
  name,
  isCustomQuery,
  query,
  ratioQuery,
  queryType,
}) =>
  linkMetricApi({
    taskId,
    metricId,
    pluginType,
    filters,
    name,
    isCustomQuery,
    query,
    ratioQuery,
    queryType,
  }).then((res) => res);

export const unlinkMetric = ({ taskId }) => unlinkMetricApi({ taskId }).then((res) => res);

export const getQueryString = ({ metricId, filters }) =>
  getQueryStringApi({ metricId, filters }).then((res) => res.entity);
